import createPersistedState from 'use-persisted-state';
export const usePersistedToggle = (key, initial) => {
  const useBoolState = createPersistedState(key);
  const [value, setValue] = useBoolState(initial);
  return {
    value,
    toggle: () => {
      setValue(!value);
    }
  };
};